(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kw-product"]) return;
  try {
    
(() => {
  const init = (root) => {
    root.querySelectorAll('[data-kw-gallery]').forEach((gallery) => {
      if (gallery.dataset.ready) return;
      const track = gallery.querySelector('.kw-gallery-track');
      const slides = Array.from(track.children);
      const controls = gallery.querySelector('.kw-gallery-controls');
      const thumbs = gallery.querySelector('.kw-gallery-thumbs');
      const count = gallery.querySelector('.kw-gallery-count');
      const loadSlide = (slide) => {
        const image = slide.querySelector('img[data-kw-gallery-src]');
        if (!image) return;
        const srcset = image.dataset.kwGallerySrcset;
        if (srcset) image.srcset = srcset;
        image.src = image.dataset.kwGallerySrc;
        image.hidden = false;
        image.removeAttribute('data-kw-gallery-src');
        image.removeAttribute('data-kw-gallery-srcset');
      };
      const mobile = matchMedia('(max-width: 760px)');
      if (mobile.matches && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            if (entry.intersectionRatio > 0) {
              loadSlide(entry.target);
              observer.unobserve(entry.target);
            }
          }
        }, {root: track, threshold: 0.01});
        slides.forEach((slide) => observer.observe(slide));
        mobile.addEventListener('change', (event) => {
          if (!event.matches) {
            slides.forEach(loadSlide);
            observer.disconnect();
          }
        });
      } else {
        slides.forEach(loadSlide);
      }

      const buttons = slides.map((slide, index) => {
        const source = slide.querySelector('img');
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'kw-gallery-thumb';
        button.setAttribute('aria-label', source.alt || slide.querySelector('figcaption')?.textContent.trim() || 'Product image ' + (index + 1));
        button.setAttribute('aria-pressed', String(index === 0));
        const image = new Image();
        const thumbnailUrl = new URL(source.dataset.kwGallerySrc || source.getAttribute('src'), document.baseURI);
        thumbnailUrl.searchParams.set('quality', '60');
        image.srcset = [54, 108, 162].map((width) => {
          thumbnailUrl.searchParams.set('width', width);
          return thumbnailUrl.href + ' ' + width + 'w';
        }).join(', ');
        thumbnailUrl.searchParams.set('width', 162);
        image.src = thumbnailUrl.href;
        image.width = 54;
        image.height = 54;
        image.fetchPriority = 'low';
        image.alt = '';
        image.loading = 'lazy';
        image.sizes = '54px';
        button.append(image);
        button.addEventListener('click', () => { loadSlide(slide); track.scrollTo({left: index * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'}); });
        thumbs.append(button);
        return button;
      });
      let lastThumbnailIndex = -1;
      const sync = () => {
        const index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / (track.clientWidth || 1))));
        buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
        count.textContent = (index + 1) + ' / ' + slides.length;
        if (index !== lastThumbnailIndex && matchMedia('(max-width: 760px)').matches) {
          const selected = buttons[index];
          thumbs.scrollTo({left: selected.offsetLeft - buttons[0].offsetLeft - (thumbs.clientWidth - selected.offsetWidth) / 2, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
          lastThumbnailIndex = index;
        }
      };
      track.addEventListener('scroll', sync, {passive: true});
      new ResizeObserver(sync).observe(track);
      sync();
      controls.hidden = slides.length < 2;
      gallery.dataset.ready = 'true';
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
